import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaClock,
  FaWhatsapp,
  FaGraduationCap,
  FaBook,
  FaInfoCircle,
} from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import {
  HOME_ROUTE,
  ABOUT_ROUTE,
  ADMISSION_ROUTE,
  CONTACT_ROUTE,
  CALENDAR_ROUTE,
  FACULTY_ROUTE,
  PRIVACY_POLICY_ROUTE,
  TERMS_ROUTE,
  SITEMAP_ROUTE,
} from "../routes/rootRoutes";

export const socialLinks = [
  {
    icon: <FaFacebook />,
    label: "Facebook",
    url: "https://www.facebook.com/share/1DTHVXqVkA/?mibextid=wwXIfr",
  },
  {
    icon: <FaInstagram />,
    label: "Instagram",
    url: "https://www.instagram.com/gyan_rashmi_shiksha_sadan_?igsh=aGhqa2pqazIybnh3",
  },
  {
    icon: <FaYoutube />,
    label: "YouTube",
    url: "https://youtube.com/@gyanrashmishikshasadan?si=3cwxh_7JwBcqwAqi",
  },
];

export const footerSections = {
  quickLinks: {
    title: "Quick Links",
    icon: <SiGoogleclassroom />,
    links: [
      { name: "Privacy & Policy", url: PRIVACY_POLICY_ROUTE, external: false },
      { name: "Terms & Condition", url: TERMS_ROUTE, external: false },
      { name: "Sitemap", url: SITEMAP_ROUTE, external: true },
    ],
  },

  academics: {
    title: "Academics",
    icon: <FaGraduationCap />,
    links: [
      { name: "Home", url: HOME_ROUTE, external: false },
      { name: "About Us", url: ABOUT_ROUTE, external: false },
      { name: "Admissions", url: ADMISSION_ROUTE, external: false },
      { name: "Facilities", url: FACULTY_ROUTE, external: false },
      { name: "Contact", url: CONTACT_ROUTE, external: false },
    ],
  },
};

export const contactInfo = [
  {
    icon: <FaMapMarkerAlt />,
    text: "ADDRESS_PLACEHOLDER",
    url: "https://maps.google.com/?q=Gyan+Rashmi+Shiksha+Sadan",
    external: true,
  },
  {
    icon: <FaPhone />,
    text: "PHONE_PLACEHOLDER",
    url: "tel:+91-CONTACT_PLACEHOLDER",
    external: false,
  },
  {
    icon: <FaEnvelope />,
    text: "EMAIL_PLACEHOLDER",
    url: "mailto:EMAIL_PLACEHOLDER",
    external: false,
  },
  {
    icon: <FaClock />,
    text: "Mon-Fri: 8:00 AM - 4:00 PM",
    url: null,
    external: false,
  },
  {
    icon: <FaWhatsapp />,
    text: "WhatsApp: PHONE_PLACEHOLDER",
    url: "https://wa.me/91CONTACT_PLACEHOLDER",
    external: true,
  },
];

export const legalLinks = [
  {
    label: "Privacy Policy",
    url: PRIVACY_POLICY_ROUTE,
    external: false,
  },
  {
    label: "Terms of Service",
    url: TERMS_ROUTE,
    external: false,
  },
  {
    label: "Sitemap",
    url: SITEMAP_ROUTE,
    external: false,
  },
];

export const schoolInfo = {
  name: "Gyan Rashmi Shiksha Sadan",
  description: "Quality Education from Pre to 10th",
  foundedYear: 1995,
  accreditation: "CBSE Affiliated",
  motto: "Learning Today, Leading Tomorrow",
};
